import { DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

import type { AgencyModel } from '@models/types'

interface BrandDetailsProps {
  agencySalesforceDetails: AgencyModel['salesforce_details'],
}

const BrandDetails = (props: BrandDetailsProps) => {
  const { agencySalesforceDetails } = props

  return (
    <DashboardModule title="Brand Details">
      <Form padding="large">
        <Form.Row>
          {/*
           // @ts-expect-error TS2739 */}
          <EntitySelector
            disabled
            entityKey="brands"
            label="Brand"
            selectedItemId={agencySalesforceDetails?.brand_id!}
          />
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default BrandDetails
